// extracted by mini-css-extract-plugin
export default {"options":"Options_options__TQ7Dl","visible":"Options_visible__Mfmq4","blur":"Options_blur__Evosd"};